import { getCredentials } from "./getCredentials";

export const requestFromToggl = async (
  url,
  method = "GET",
  body,
  successCb,
  failCb
) => {
  getCredentials((credentials) => {
    let request = {
      // mode: "no-cors",
      method: method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${credentials}`,
      },
    };

    console.log(url, method, body, credentials);
    if (method === "POST" || method === "PUT") {
      request.body = JSON.stringify(body);
    }
    return fetch(url, request)
      .then((response) => response.json())
      .then((data) => {
        successCb(data);
      })
      .catch((error) => {
        console.log(error);
        if (failCb) failCb(error);
        // setTimeout(() => {
        //   requestFromToggl(url, method, body, successCb, failCb);
        //   console.log("Retrying...");
        // }, 1000);
      });
  });
};
